import { replaceMultiSelect } from '../inputs/MultiSelect'
import type { FiltersOptions, FiltersState } from './filterState'
import {
	renderGenreFilter,
	renderStyleFilter,
	renderYearRangeOptions,
} from './filterTemplates'

type FilterOptionsUpdate = Pick<
	FiltersOptions,
	'genreOptions' | 'styleOptions' | 'yearRange'
>

/** Updates dynamic options without resetting the rest of the filter form. */
export function updateFilterOptions(
	containerId: string,
	state: FiltersState,
	options: FilterOptionsUpdate,
	rootEl: ParentNode = document,
): void {
	const container = rootEl.querySelector<HTMLElement>(`#${containerId}`)
	if (!container) return
	for (const [selectId, values, render] of [
		['col-genre-filter', options.genreOptions, renderGenreFilter],
		['col-style-filter', options.styleOptions, renderStyleFilter],
	] as const) {
		const control = container.querySelector<HTMLElement>(
			`.tt-multi-select[data-select-id="${selectId}"]`,
		)
		if (control && values)
			replaceMultiSelect(
				container,
				control,
				render(
					selectId === 'col-genre-filter' ? state.genre : state.style,
					values,
				),
			)
	}
	if (!options.yearRange) return
	for (const which of ['from', 'to'] as const) {
		const select = container.querySelector<HTMLSelectElement>(
			`#col-year-${which}-filter`,
		)
		if (select)
			select.innerHTML = renderYearRangeOptions(
				state.yearFrom,
				state.yearTo,
				options.yearRange,
				which,
			)
	}
}
